import React, { Component } from "react";
import {
  Row,
  Col,
  Form,
  Button,
  Card,
  Input,
  message,
  Select,
  Spin,
} from "antd";
import axios from "services/axios";

const FormItem = Form.Item;
const { Option } = Select;

class NewCarAreaUpdate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      area: {},
      bohUsers: [],
      pricingAreas: [],
      isLoading: false,
    };
  }

  componentDidMount() {
    this.fetchAreaPricing();
    this.fetchBOH();
    this.fetchNewCarAreaById(this.props.match.params.id);
  }

  async fetchAreaPricing() {
    const {
      data: { areas },
    } = await axios.get(`/misc/area-pricing`);
    this.setState({ pricingAreas: areas });
  }

  async fetchBOH() {
    const {
      data: { bohUsers },
    } = await axios.get(`/misc/boh-users`);
    this.setState({ bohUsers });
  }

  async fetchNewCarAreaById(id) {
    const {
      data: { area },
    } = await axios.get(`/admin-panel/new-car-area/${id}`);
    this.setState({ area });
  }

  async updateNewCarArea(e) {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      this.setState({ isLoading: true });
      if (!err) {
        let id = this.props.match.params.id;
        axios
          .patch(`/admin-panel/new-car-area/${id}/update`, values)
          .then(result => {
            message.success(`Berhasil update Area ${values.name}`);
            this.props.history.push(`/home/new-car-area`);
          })
          .catch(err => {
            this.errorMessage(err);
          });
      }
      this.setState({ isLoading: false });
    });
  }

  callback(key, props) {
    props.form.resetFields();
  }

  errorMessage(e) {
    if (e.response) {
      if (e.response.data || e.response.message) {
        message.error(
          e.response.data.message || e.response.message || e.response.data
        );
      } else {
        message.error("Error Update Area");
      }
    } else {
      message.error("Error Update Area");
    }
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Card title="Update New Car Area">
        <Spin tip="Sedang mengupdate Area" spinning={this.state.isLoading}>
          <Form onSubmit={e => this.updateNewCarArea(e)}>
            <FormItem label="Area">
              {getFieldDecorator("name", {
                initialValue: this.state.area ? this.state.area.name : "",
                rules: [{ required: true, message: "Area wajib diisi" }],
              })(<Input />)}
            </FormItem>

            <Row type="flex" justify="end">
              <Col>
                <Button htmlType="submit" type="primary">
                  Update
                </Button>
              </Col>
            </Row>
          </Form>
        </Spin>
      </Card>
    );
  }
}

export default Form.create()(NewCarAreaUpdate);



// WEBPACK FOOTER //
// src/components/Dashboard/Area/NewCarArea/NewCarAreaUpdate.js